import { render } from "./PostDetailPage.vue?vue&type=template&id=16dc210f"
import script from "./PostDetailPage.vue?vue&type=script&lang=ts"
export * from "./PostDetailPage.vue?vue&type=script&lang=ts"
script.render = render

export default script